module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_null@2x.615adf67.png";